import { gql, TypedDocumentNode } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import Module from "module";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { Version } from "types/generated";

type YankVersionData = {
  versionYank: Pick<Version, "id">;
};

type YankVersionVariables = {
  moduleId: string;
  id: string;
  note?: string | null;
};

const YANK_VERSION: TypedDocumentNode<YankVersionData, YankVersionVariables> = gql`
  mutation YankVersion($moduleId: ID!, $id: ID!, $note: String) {
    versionYank(module: $moduleId, id: $id, note: $note) {
      id
    }
  }
`;

type UseYankVersion = {
  moduleId: Module["id"];
  id: Module["id"];
  note: string;
};

export const useYankVersion = ({ moduleId, id, note }: UseYankVersion) => {
  const { reportSuccess } = useTypedContext(FlashContext);
  const [yankVersion, { loading }] = useMutation(YANK_VERSION, {
    variables: { moduleId, id, note },
    refetchQueries: ["GetVersionNext", "GetModuleVersionsNext", "GetModule"],
    awaitRefetchQueries: true,
    // APOLLO CLIENT UPDATE
    onCompleted() {
      reportSuccess({ message: "Version was marked as bad" });
    },
  });

  return { yankVersion, loading };
};
